var _excluded = ["children", "data-test-id"],
    _excluded2 = ["isFocusable", "palette"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { useMenuItem } from "./useMenuItem";
import { ListItem } from "../../internal/list";
import { getMenuItemStyles } from "./MenuItem.styles";
import { MenuItemContext } from "./MenuItemContext";
export var MenuItem = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      dataTestId = props['data-test-id'],
      rest = _objectWithoutProperties(props, _excluded);

  var _useMenuItem = useMenuItem(rest, ref),
      isFocusable = _useMenuItem.isFocusable,
      palette = _useMenuItem.palette,
      listItemProps = _objectWithoutProperties(_useMenuItem, _excluded2);

  var listStyles = getMenuItemStyles({
    palette: palette,
    isFocusable: isFocusable
  });
  return /*#__PURE__*/React.createElement(MenuItemContext.Provider, {
    value: {
      palette: palette,
      isFocusable: isFocusable
    }
  }, /*#__PURE__*/React.createElement(ListItem, _extends({
    "data-test-id": dataTestId,
    sx: listStyles,
    alignItems: "center"
  }, listItemProps), children));
});
MenuItem.displayName = 'MenuItem';